(function ($) {
  Drupal.behaviors.desire_products_v1 = {
    attach: function (context) {
      $('#desire_mod3', context).once(function () {
        var thisModuleName = 'desire_mod3',
          triggerMod = '#desire_mod3',
          $thismodule = $('#desire_mod3');
        // If module is called in URL, scroll to module.
        var urlHash = window.location.href.split('#')[1];
        // Background Color
        var moduleBackground = $thismodule.data('module-background') || 'dark';
        // Fade in
        var moduleWillFade = false;
        var hasFaded = false;
        // Init scrollMagic Controller Class
        var controller = new ScrollMagic.Controller();
        var offset;
        // Set the parallax duration
        var windowHeight = $(window).height();
        var parallaxDuration = windowHeight / 1.1;
        var desire_mod3_scene1;
        var fadeThisModuleScene;

        urlHashCheck();

        function urlHashCheck() {
          if (urlHash === thisModuleName) {
            $('html,body').animate({
              scrollTop: $thismodule.offset().top - 85
            }, 1500);
          }
        }

        // Apply a css class to the module wrapper based on background in data-module-background
        $thismodule.parent().parent().addClass('desire__module-' + moduleBackground + '-bg');

        // Set the scene/
        desire_mod3_scene1 = new ScrollMagic.Scene({
          triggerElement: '#desire_mod3',
          offset: -150,
          duration: parallaxDuration
        })
          .setTween('.js-desire_mod3__parallax', 8, {
            top: '-57.5%',
            ease: Linear.easeNone
          })
          .addTo(controller);

        // Check if Content Author has specified for module
        // to fade in.
        if ($thismodule.data('scrollmagic') === 1) {
          moduleWillFade = true;
          // Hide and push down the module if it is to be faded in.
          $thismodule.addClass('hideModules');
        }

        // Handle module fade-in from CMS.
        function fadeThisModule() {
          if (hasFaded === false) {
            hasFaded = true;
            $thismodule.animate({
              opacity: 1,
              paddingTop: '0'
            }, 350, 'easeOutQuad');
          } else {
            return;
          }
        }

        // Content-Author-managed - Module Fade.
        if (moduleWillFade) {
          // Set the offset.
          if ($thismodule.data('offset')) {
            offset = $thismodule.data('offset');
          } else {
            offset = 0;
          }

          // Init scrollMagic Scene Class
          fadeThisModuleScene = new ScrollMagic.Scene({
            triggerElement: triggerMod,
            offset: offset
          }).on('start', function () {
            fadeThisModule();
          });
          controller.addScene([fadeThisModuleScene]);
        }
      });
    }
  };
})(jQuery);
